import { useState } from 'react';

import { KycFlow } from '#src/components/kyc/KycFlow/index.tsx';

import { AccountVerificationContext } from './AccountVerification/AccountVerificationContext.tsx';
import { IdentityVerificationCTA } from './AccountVerification/IdentityVerificationCTA/index.tsx';
import { AccountVerification } from './AccountVerification/index.tsx';
import { JonumVerificationInProgress } from './JonumVerificationInProgress/index.tsx';
import {
  useJonumVerificationGuard,
  withoutKycInfo,
} from './useJonumVerificationGuard.ts';

type Props = {
  onDone: () => void;
};

export const JonumKycPromptView = ({ onDone }: Props) => {
  const {
    infoRequired,
    kycRequired,
    mangopayKycUnderReview,
    missingInfo,
    onStepComplete,
  } = useJonumVerificationGuard();
  const [collectsInfo] = useState(infoRequired);
  const [infoStepsCompleted, setInfoStepsCompleted] = useState(false);
  const [showKycFlow, setShowKycFlow] = useState(false);

  if (collectsInfo && !infoStepsCompleted) {
    return (
      <AccountVerification
        showIntro={false}
        missingInfo={withoutKycInfo(missingInfo)}
        onStepComplete={onStepComplete}
        onComplete={() => {
          if (kycRequired && !mangopayKycUnderReview) {
            setInfoStepsCompleted(true);
          } else {
            onDone();
          }
        }}
        onSkip={onDone}
        onBack={onDone}
      />
    );
  }

  if (showKycFlow) {
    return (
      <KycFlow
        onDone={onDone}
        renderVerificationInProgress={({ onDone: onJonumDone }) => (
          <JonumVerificationInProgress onDone={onJonumDone} />
        )}
      />
    );
  }

  return (
    <AccountVerificationContext
      value={{ onSkip: onDone, updateData: () => {}, loading: false }}
    >
      <IdentityVerificationCTA onNext={() => setShowKycFlow(true)} />
    </AccountVerificationContext>
  );
};
